import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot} from '@angular/router';
import { Injectable } from '@angular/core';
import {first, map} from 'rxjs/operators';
import { Observable } from 'rxjs';

import { StaffService } from '../shared/services/staff.service';

@Injectable()
export class StaffListResolver implements Resolve<any> {
    constructor(
        private staffService: StaffService
    ) {}
  
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
        return this.staffService.getActiveStaffs().pipe(map((result: any) => {
            if (result.hasOwnProperty('success') && result.success === false) {
                return null;
            }

            return result;
        }),first(),);
    }
  }
